import { defineTextStyles } from '@chakra-ui/react'

export const typographyValues = {
  fontFamily: {
    body: 'Manrope, sans-serif',
    heading: 'Manrope, sans-serif',
    mono: 'monospace',
  },
  fontSize: {
    xs: '0.75rem',
    sm: '0.875rem',
    button: '0.9375rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
  },
  fontWeight: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  lineHeight: {
    tight: 1.2,
    snug: 1.35,
    normal: 1.5,
    relaxed: 1.625,
  },
  letterSpacing: {
    tight: '-0.01em',
    normal: '0',
    button: '0.01em',
    wide: '0.02em',
  },
} as const

export const typographyTokens = {
  fonts: {
    body: { value: typographyValues.fontFamily.body },
    heading: { value: typographyValues.fontFamily.heading },
    mono: { value: typographyValues.fontFamily.mono },
  },
  fontSizes: {
    xs: { value: typographyValues.fontSize.xs },
    sm: { value: typographyValues.fontSize.sm },
    button: { value: typographyValues.fontSize.button },
    md: { value: typographyValues.fontSize.md },
    lg: { value: typographyValues.fontSize.lg },
    xl: { value: typographyValues.fontSize.xl },
    '2xl': { value: typographyValues.fontSize['2xl'] },
    '3xl': { value: typographyValues.fontSize['3xl'] },
  },
  fontWeights: {
    normal: { value: typographyValues.fontWeight.normal },
    medium: { value: typographyValues.fontWeight.medium },
    semibold: { value: typographyValues.fontWeight.semibold },
    bold: { value: typographyValues.fontWeight.bold },
  },
  lineHeights: {
    tight: { value: typographyValues.lineHeight.tight },
    snug: { value: typographyValues.lineHeight.snug },
    normal: { value: typographyValues.lineHeight.normal },
    relaxed: { value: typographyValues.lineHeight.relaxed },
  },
  letterSpacings: {
    tight: { value: typographyValues.letterSpacing.tight },
    normal: { value: typographyValues.letterSpacing.normal },
    button: { value: typographyValues.letterSpacing.button },
    wide: { value: typographyValues.letterSpacing.wide },
  },
}

export const textStyles = defineTextStyles({
  buttonStandalone: {
    value: {
      fontFamily: 'body',
      fontSize: 'button',
      fontWeight: 'bold',
      letterSpacing: 'button',
      lineHeight: 'normal',
    },
  },
  buttonCompact: {
    value: {
      fontFamily: 'body',
      fontSize: '12px',
      fontWeight: 'normal',
      lineHeight: 'normal',
    },
  },
  bodySm: {
    value: {
      fontFamily: 'body',
      fontSize: 'sm',
      fontWeight: 'normal',
      lineHeight: 'normal',
    },
  },
  bodyMd: {
    value: {
      fontFamily: 'body',
      fontSize: 'md',
      fontWeight: 'normal',
      lineHeight: 'normal',
    },
  },
  labelSm: {
    value: {
      fontFamily: 'body',
      fontSize: 'sm',
      fontWeight: 'semibold',
      lineHeight: 'tight',
    },
  },
  labelMd: {
    value: {
      fontFamily: 'body',
      fontSize: 'md',
      fontWeight: 'semibold',
      lineHeight: 'tight',
    },
  },
  headingSm: {
    value: {
      fontFamily: 'heading',
      fontSize: 'lg',
      fontWeight: 'semibold',
      lineHeight: 'snug',
      letterSpacing: 'tight',
    },
  },
  headingMd: {
    value: {
      fontFamily: 'heading',
      fontSize: '2xl',
      fontWeight: 'semibold',
      lineHeight: 'tight',
      letterSpacing: 'tight',
    },
  },
  headingLg: {
    value: {
      fontFamily: 'heading',
      fontSize: '3xl',
      fontWeight: 'bold',
      lineHeight: 'tight',
      letterSpacing: 'tight',
    },
  },
})
